// Suppress ResizeObserver errors - these are benign and caused by rapid chart resizing
// This is a known issue with Recharts and doesn't affect functionality

const suppressResizeObserverErrors = () => {
  // Debounce ResizeObserver to prevent loops
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // Override ResizeObserver with debounced version
  if (typeof window.ResizeObserver !== 'undefined') {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
      constructor(callback) {
        const debouncedCallback = debounce(callback, 20);
        super(debouncedCallback);
      }
    };
  }

  // Store original error handler
  const originalError = window.console.error;
  
  // Override console.error
  window.console.error = (...args) => {
    const errorMessage = String(args[0] || '');
    
    // Suppress ResizeObserver errors
    if (
      errorMessage.includes('ResizeObserver') ||
      errorMessage.includes('loop limit exceeded') ||
      errorMessage.includes('loop completed with undelivered notifications')
    ) {
      return;
    }
    
    // Call original for other errors
    originalError.apply(window.console, args);
  };

  // Suppress in window.error
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    const msg = String(message || '');
    if (
      msg.includes('ResizeObserver') ||
      msg.includes('loop limit exceeded') ||
      msg.includes('loop completed with undelivered notifications')
    ) {
      return true; // Prevent default error handling
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Handle error events
  window.addEventListener('error', (event) => {
    if (event.message && String(event.message).includes('ResizeObserver')) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  }, true);
  
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const reason = String(event.reason?.message || event.reason || '');
    if (reason.includes('ResizeObserver')) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  });
};

export default suppressResizeObserverErrors;
